export default {
  title: 'Ohodnoťte přednášku',
  questions: [
    { id: 'kvalita', type: 'rate', label: 'Presentation' },
    { id: 'prednasajuci', type: 'rate', label: 'Presenter' },
    { id: 'ine', type: 'multiline', label: 'Other' },
  ],
}



// WEBPACK FOOTER //
// ./src/content/biznisnet2020/addons/feedback/presentation.js